<div class="mat-modal-dialog vehicle-count-modal">
    <h2 mat-dialog-title>
        <span class="material-icons-outlined"
            style="color: #FF0000; font-size: 19px; position: relative; top: 5px; margin-right: 10px;">
            info</span><span class="vthtitle">Vehicle Type Count</span>
        <mat-icon style="color:#FF0000; float: right; cursor: pointer; position: relative; top: 10px;"
            (click)="onClickCancel()">close</mat-icon>
    </h2>
</div>
<hr>
<mat-dialog-content style="height: 250px;">
    <div class="row">
        <div class="table-vth" style="background-color: #F5FCFF;">
            <table class="table table-responsive">
                <tr>
                    <th class="vTh" style="color: #000000;">Vendor Name</th>
                    <th class="vTh" style="color: #000000;" *ngFor="let item of vechileNames">{{item}}</th>
                </tr>
                <tr *ngFor="let vh of vechileTypeCount">
                    <td class="vTd" style="color: #495057;">{{vh.name}}</td>
                    <td class="vTd" style="color: #495057;" *ngFor="let x of vechileNames">{{vh[x]}}</td>
                </tr>
            </table>
        </div>
    </div>
</mat-dialog-content>